// extracted by mini-css-extract-plugin
export default {"createCardContainer":"CreateCard_createCardContainer__+crn4","tabsWithStatusWrapper":"CreateCard_tabsWithStatusWrapper__DTgpv","tabWrapperClass":"CreateCard_tabWrapperClass__4j1IY"};